module.exports = __webpack_public_path__ + "assets/img/FaceRecognition-banner.6345cb48.png";